import { useState } from 'react';
import { Link } from 'react-router-dom';
import PanelLayout from '../components/PanelLayout';
import { conversationsList } from '@/mocks/therapistPanel';

export default function GorusmelerPage() {
  const [filter, setFilter] = useState('all');

  const statusBadge = (status: string) => {
    const map: Record<string, string> = {
      'görüşme başladı': 'bg-dark-teal-50 text-dark-teal-500',
      'telefon paylaşıldı': 'bg-soft-gold-100 text-soft-gold-700',
      beklemede: 'bg-amber-50 text-amber-600',
      'işe başladı': 'bg-green-50 text-green-600',
      'süreç kapandı': 'bg-gray-100 text-gray-500',
      'uygun bulunmadı': 'bg-gray-100 text-gray-500',
    };
    return map[status] || 'bg-gray-100 text-gray-500';
  };

  const filtered = filter === 'all'
    ? conversationsList
    : conversationsList.filter((c) => {
        if (filter === 'active') return c.status === 'görüşme başladı' || c.status === 'telefon paylaşıldı' || c.status === 'beklemede';
        if (filter === 'closed') return c.status === 'süreç kapandı' || c.status === 'uygun bulunmadı';
        return true;
      });

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">Görüşmelerim</h1>
          <p className="text-sm text-gray-500 mt-1">
            Spa işletmeleriyle olan aktif görüşmeleriniz. Detaylı chat bu ekrandan erişilebilir.
          </p>
        </div>

        {/* Filters */}
        <div className="flex gap-2 mb-6 overflow-x-auto pb-1">
          {[
            { id: 'all', label: 'Tümü', count: conversationsList.length },
            { id: 'active', label: 'Devam Eden', count: conversationsList.filter((c) => c.status === 'görüşme başladı' || c.status === 'telefon paylaşıldı' || c.status === 'beklemede').length },
            { id: 'closed', label: 'Kapalı', count: conversationsList.filter((c) => c.status === 'süreç kapandı' || c.status === 'uygun bulunmadı').length },
          ].map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors whitespace-nowrap cursor-pointer ${
                filter === f.id
                  ? 'bg-dark-teal-500 text-white border-dark-teal-500'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300'
              }`}
            >
              {f.label} ({f.count})
            </button>
          ))}
        </div>

        <div className="space-y-3">
          {filtered.map((conv) => (
            <div
              key={conv.id}
              className="bg-white rounded-xl border border-gray-100 p-4 hover:border-gray-200 transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-deep-navy-500">{conv.spaType}</span>
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${statusBadge(conv.status)}`}>
                      {conv.status}
                    </span>
                    {conv.unread && (
                      <span className="w-2 h-2 rounded-full bg-dark-teal-500" />
                    )}
                  </div>
                  <p className="text-xs text-gray-500">{conv.city}</p>
                  <p className="text-sm text-gray-600 mt-2 truncate">{conv.lastMessage}</p>
                  <p className="text-[10px] text-gray-400 mt-1">{conv.lastDate}</p>
                </div>
                <Link
                  to={`/terapist-panel/gorusmeler/${conv.id}`}
                  className="px-4 py-2 rounded-lg bg-dark-teal-500 text-white text-xs font-medium hover:bg-dark-teal-600 transition-colors shrink-0 cursor-pointer whitespace-nowrap"
                >
                  Görüşmeye Git
                </Link>
              </div>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-chat-3-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Bu kategoride görüşme bulunmuyor.</p>
          </div>
        )}

        {/* Chat UI Placeholder Note */}
        <div className="mt-6 bg-gray-50 border border-gray-100 rounded-xl p-4 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0 mt-0.5">
            <i className="ri-information-line text-base" />
          </span>
          <div>
            <p className="text-sm font-medium text-gray-600">Chat detayı yakında</p>
            <p className="text-xs text-gray-500 mt-1">
              Görüşmeye Git butonu chat ekranına yönlendirecek. Chat detay ekranı sonraki aşamada geliştirilecektir.
            </p>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}